import { addonsWithRelatedInput } from '../constants/supersizeMyEditAddons';

export default function isInvalidAddon(option) {
  return addonsWithRelatedInput.includes(option.value) && !option.description;
}